<template>
    <el-menu class="navbar" mode="horizontal">
        <hamburger
            class="hamburger-container"
            :toggleClick="toggleSideBar"
            :isActive="sidebar.opened"
        ></hamburger>
        <breadcrumb></breadcrumb>
        <el-dropdown class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
                <el-image class="user-avatar" :src="merchantLogo">
                    <div slot="error" class="image-slot">
                        <el-image
                            :src="require('@/assets/images/defalut-icon.png')"
                        ></el-image>
                    </div>
                </el-image>
                <span>{{ merchant || "" }}</span>
                <i class="el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu class="user-dropdown" slot="dropdown">
                <router-link class="inlineBlock" to="/">
                    <el-dropdown-item> 首页 </el-dropdown-item>
                </router-link>
                <router-link
                    v-if="roles == '店铺管理员' || roles == '待注销角色'"
                    class="inlineBlock"
                    to="/pms/userinfo"
                >
                    <el-dropdown-item> 店铺信息 </el-dropdown-item>
                </router-link>
                <router-link
                    v-if="roles == '店铺管理员'"
                    class="inlineBlock"
                    to="/pms/warehouse"
                >
                    <el-dropdown-item> 仓库设置 </el-dropdown-item>
                </router-link>
                <el-dropdown-item divided>
                    <span @click="changepwd" style="display: block"
                        >修改密码</span
                    >
                </el-dropdown-item>
                <el-dropdown-item divided>
                    <span @click="logout" style="display: block">退出</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <!-- ========== 修改密码弹窗（同登录页忘记密码流程） ========== -->
        <el-dialog
            title="修改密码"
            :visible.sync="dialogVisible"
            width="440px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                :model="member"
                :rules="memberRules"
                ref="memberForm"
                label-width="90px"
            >
                <el-form-item label="手机号" prop="phone">
                    <el-input
                        v-model="member.phone"
                        placeholder="请输入绑定手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="smsCode">
                    <div style="display: flex; gap: 10px">
                        <el-input
                            v-model="member.smsCode"
                            placeholder="验证码"
                            style="flex: 1"
                        ></el-input>
                        <el-button
                            :disabled="smsCountDown > 0"
                            @click="getSmsCode"
                        >
                            {{
                                smsCountDown > 0
                                    ? `${smsCountDown}s`
                                    : "获取验证码"
                            }}
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input
                        v-model="member.newPassword"
                        type="password"
                        placeholder="请设置新密码"
                        show-password
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="newPassword2">
                    <el-input
                        v-model="member.newPassword2"
                        type="password"
                        placeholder="再次输入新密码"
                        show-password
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    :loading="changePwdLoading"
                    @click="handleDialogConfirm()"
                    size="small"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- ========== 图形验证码弹窗（图形验证码弹窗）点击获取验证码弹出 ========== -->
        <el-dialog
            title="请输入图形验证码"
            :visible.sync="captchaDialogVisible"
            width="400px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form :model="captchaForm" ref="captchaForm">
                <el-form-item label="图形验证码" label-width="100px">
                    <div style="display: flex; gap: 10px; align-items: center">
                        <el-input
                            v-model="captchaForm.captchaCode"
                            placeholder="输入图片验证码"
                        ></el-input>
                        <!-- 图形验证码图片，点击刷新 -->
                        <img
                            :src="captchaImgSrc"
                            @click="refreshCaptcha"
                            style="
                                height: 40px;
                                cursor: pointer;
                                border: 1px solid #ccc;
                            "
                            alt="验证码"
                        />
                    </div>
                    <div style="font-size: 12px; color: #999; margin-top: 4px">
                        点击图片可刷新图形验证码
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="captchaDialogVisible = false"
                    >取消</el-button
                >
                <el-button type="primary" @click="confirmCaptcha"
                    >确定</el-button
                >
            </div>
        </el-dialog>
    </el-menu>
</template>
<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import {
    getInfo,
    getSign,
    userupdatepassword,
    sendSmsCodeByCaptcha,
    getCaptchaImgApi,
} from "@/api/login.js";
export default {
    components: {
        Breadcrumb,
        Hamburger,
    },
    data() {
        // 两次密码一致校验
        const validateConfirmPwd = (rule, value, callback) => {
            if (value !== this.member.newPassword) {
                callback(new Error("两次输入密码不一致"));
            } else {
                callback();
            }
        };
        return {
            merchantLogo: "",
            merchant: "",
            roles: [],
            dialogVisible: false,
            changePwdLoading: false,
            member: {
                phone: "",
                smsCode: "",
                newPassword: "",
                newPassword2: "",
            },
            memberRules: {
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: "手机号格式错误",
                        trigger: "blur",
                    },
                ],
                smsCode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "blur",
                    },
                ],
                newPassword: [
                    {
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur",
                    },
                    { min: 3, message: "密码至少3位", trigger: "blur" },
                ],
                newPassword2: [
                    { required: true, message: "请确认密码", trigger: "blur" },
                    { validator: validateConfirmPwd, trigger: "blur" },
                ],
            },
            smsCountDown: 0, // 短信倒计时
            timer: null,
            // ========== 图形验证码弹窗 ==========
            captchaDialogVisible: false,
            captchaForm: {
                captchaCode: "",
            },
            captchaImgSrc: "", // 图形验证码图片地址
            captchaKey: "", // 后端返回验证码key，发接口要带上
        };
    },
    computed: {
        ...mapGetters(["sidebar"]),
    },
    created() {
        this.getMerchantLogo();
    },
    beforeDestroy() {
        // 销毁清除倒计时，防止内存泄漏
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        getMerchantLogo() {
            getInfo().then((response) => {
                console.log(response, "response");
                if (response.data && response.data.username) {
                    this.merchantLogo = response.data.icon;
                    this.merchant = response.data.username;
                    this.roles = response.data.roles[0];
                }
            });
        },
        toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
        },
        logout() {
            this.$store.dispatch("LogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
        },
        changepwd() {
            this.member = {
                phone: "",
                smsCode: "",
                newPassword: "",
                newPassword2: "",
            };
            this.smsCountDown = 0;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.$nextTick(() => {
                this.$refs.memberForm && this.$refs.memberForm.clearValidate();
            });
            this.dialogVisible = true;
        },
        // ========== 获取短信验证码：先校验手机号，弹出图形验证码弹窗 ==========
        getSmsCode() {
            this.$refs.memberForm.validateField("phone", async (errMsg) => {
                if (errMsg) return;
                // 打开图形验证码弹窗，加载图形验证码
                this.captchaForm.captchaCode = "";
                this.refreshCaptcha();
                this.captchaDialogVisible = true;
            });
        },
        // ========== 刷新图形图形验证码 ==========
        async refreshCaptcha() {
            try {
                const res = await getCaptchaImgApi();
                this.captchaImgSrc = res.data.image;
                this.captchaKey = res.data.key;
            } catch (e) {
                this.$message.error("获取图形验证码失败");
            }
        },
        // ========== 图形验证码弹窗点击确定，校验图形验证码，请求发送短信 ==========
        async confirmCaptcha() {
            if (!this.captchaForm.captchaCode) {
                this.$message.warning("请输入图形验证码");
                return;
            }
            try {
                const res = await sendSmsCodeByCaptcha({
                    telephone: this.member.phone,
                    key: this.captchaKey,
                    code: this.captchaForm.captchaCode,
                });
                this.$message.success("短信验证码已发送");
                this.captchaDialogVisible = false;
                // 开启倒计时60秒
                this.smsCountDown = 60;
                this.timer = setInterval(() => {
                    this.smsCountDown--;
                    if (this.smsCountDown <= 0) {
                        clearInterval(this.timer);
                    }
                }, 1000);
            } catch (err) {
                this.refreshCaptcha(); // 错误刷新验证码
            }
        },
        // ========== 提交修改密码 ==========
        handleDialogConfirm() {
            this.$refs.memberForm.validate((valid) => {
                if (!valid) return;
                this.$confirm("是否要确认?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    if (this.member.newPassword2 !== this.member.newPassword) {
                        this.$message({
                            message: "两次密码输入不一致！",
                            type: "error",
                        });
                        return false;
                    }
                    this.changePwdLoading = true;
                    // 【调用修改密码接口，字段按后端实际调整】
                    userupdatepassword({
                        username: this.member.phone,
                        telephone: this.member.phone,
                        authcode: this.member.smsCode,
                        password: this.member.newPassword,
                        checkPassword: this.member.newPassword2,
                    })
                        .then((response) => {
                            this.$message({
                                message: "修改成功！",
                                type: "success",
                            });
                            this.dialogVisible = false;
                        })
                        .finally(() => {
                            this.changePwdLoading = false;
                        });
                });
            });
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    .hamburger-container {
        line-height: 58px;
        height: 50px;
        float: left;
        padding: 0 10px;
    }
    .screenfull {
        position: absolute;
        right: 90px;
        top: 16px;
        color: red;
    }
    .avatar-container {
        height: 50px;
        display: inline-block;
        position: absolute;
        right: 35px;
        .avatar-wrapper {
            cursor: pointer;
            margin-top: 5px;
            position: relative;
            display: flex;
            justify-content: center;
            align-content: center;
            .user-avatar {
                width: 40px;
                height: 40px;
                border-radius: 10px;
                margin-right: 10px;
            }
            span {
                line-height: 40px;
            }
            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 12px;
                font-size: 12px;
            }
        }
    }
}
</style>
